import { t } from 'frontend/js/modules/infra/i18n';
import { mockAutomatedData } from './mock';
import { MetricType } from './types';
// TODO: Connect with real data when be is ready
export var useMetrics = function () {
    var metrics = new Map([
        [
            MetricType.AUDIENCE,
            {
                title: t('engage:automated.metrics.audience'),
                value: "".concat(mockAutomatedData.metrics.audience.count.toLocaleString(), " ").concat(t('engage:automated.metrics.clients')),
                subtitle: mockAutomatedData.metrics.audience.description,
            },
        ],
        [
            MetricType.SENT,
            {
                title: t('engage:automated.metrics.sent'),
                value: "".concat(mockAutomatedData.metrics.sent.campaigns, " ").concat(t('engage:automated.metrics.campaigns')),
                subtitle: mockAutomatedData.metrics.sent.since,
            },
        ],
        [
            MetricType.OPEN_RATE,
            {
                title: t('engage:automated.metrics.open_rate'),
                value: "".concat(mockAutomatedData.metrics.openRate.percentage, "%"),
                subtitle: "".concat(mockAutomatedData.metrics.openRate.clients, " ").concat(t('engage:automated.metrics.clients')),
            },
        ],
    ]);
    return {
        metrics: metrics,
    };
};
